import React from 'react';
import { Box, AccordionItem, Button } from 'components';
import { observer } from 'mobx-react';
import { Warning } from 'icons';
import useFileInput from 'libs/useFileInput';
import { getMessageFromRequirement } from 'apps/rfq/fileRequirementsUtils';

interface SupportingFileIssueProps {
  rfqManager: any;
  supportingFileRequirement: any;
}

export const SupportingFileIssue = observer(function SupportingFileIssue({
  supportingFileRequirement,
  rfqManager,
}: SupportingFileIssueProps) {
  const acceptSupportingFilesFormats =
    supportingFileRequirement.formats.join(',');

  const selectSupportingFile = useFileInput(
    (fileList: any) => {
      if (fileList.length > 0) rfqManager.AddSupportingFiles(fileList);
    },
    {
      accept: acceptSupportingFilesFormats,
    },
  );

  const title = 'Supporting File Required';
  const message = getMessageFromRequirement(supportingFileRequirement);

  return (
    <Box mb={4}>
      <AccordionItem
        icon={<Warning />}
        divisor
        title={title}
        content={message}
        button={
          <Button
            text='Upload File'
            icon='upload'
            iconPosition='right'
            variant='tertiary'
            size='small'
            outline
            onClick={selectSupportingFile}
            data-testid='rfqPage-upload-supporting-file-requirement-button'
          />
        }
      />
    </Box>
  );
});
